/**
 * @name Filters
 * @function
 * @description filters publications array using filter options 
 * @param {array}  publications string
 * @param {number} sort Hash string
 * @param {number} year Hash string
 * @returns {array} array of filter items
 */
export const Filters = (publications, sort, year) => {
  return publications.sort(( a, b ) => {
    if( a.publishDate > b.publishDate ) return sort;
    if( a.publishDate < b.publishDate ) return -sort;
    return 0;
    }).filter( publication => {
      if( year ) return publication.publishDate.getFullYear() === year;
      return true;
    });
}

/**
 * @name Decades
 * @function
 * @description construct year dropdown items 
 * @param {object}  Publication object
 * @returns {array} array of years
 */
export const Decades = ( publications ) => {

  let volumes = publications.reverse(),
      length = volumes.length,
      first = volumes[ 0 ].publishDate,
      last = volumes[ length - 1 ].publishDate,
      lastDecade = ( Math.floor( last.getFullYear() / 10 ) * 10 ),
      decades = [{ value: 'All' }];

      for( let decade = lastDecade; decade > first.getFullYear(); decade -= 10 ){

          let years = [];
          for( let year = decade; year < ( decade + 10 ); ++year ){
              if( year <= last.getFullYear() && year >= first.getFullYear() ) years.push({ value: year });
          }

          decades.push({ value: `${ decade }s`, children: years.reverse() });
      }
      return decades;
        
}

/**
 * @name ModifyDate
 * @function
 * @description modify publication publish date 
 * @param {object}  publication object
 * @returns {object} object of modified publication
 */
export const ModifyDate = publication => {
  let date = publication.publishDate.split( '-' ),
  day = '01',
  month = date[ 0 ],
  year = date[ 1 ];

  publication.publishDate = new Date( `${ month }/${ day }/${ year }` );
  return publication;
}